'use strict';
(function() {
    App.filter('groupLifeInsurances', groupLifeInsurances);
    
    groupLifeInsurances.$inject = [];

    function groupLifeInsurances() {

        /**
         * This filter is suitable for the API's lifeInsuranceDeclaration/allDeclarations response;
         *
         * Returns object of grouped declarations (for 'USER', 'PARTNER' and 'CHILD');
         * If type is not defined or it is not one of three ('USER', 'PARTNER' or 'CHILD'), declaration will be appended to the 'other' group;
         */
        return function (declarations) {
            if (!angular.isDefined(declarations.declarations)) {
                return declarations;
            }

            var unwrapped = declarations.declarations,
                grouped = {
                    user: [],
                    partner: [],
                    child: [],
                    other: []
                };

            angular.forEach(unwrapped, function (value, key) {
                if (angular.isDefined(value.type)) {
                    switch (value.type) {
                        case 'USER':
                            grouped.user.push(value);
                            break;
                        case 'PARTNER':
                            grouped.partner.push(value);
                            break;
                        case 'CHILD':
                            handleChild(grouped, value);
                            break;
                        default:
                            grouped.other.push(value);
                    }
                } else {
                    grouped.other.push(value);
                }
            });

            if (grouped.other.length) {
                console.warn('GroupLifeInsurance filter: Group \'other\' not empty ' + angular.toJson(grouped.other));
            }

            console.log('grouped', grouped);
            return grouped;
        };

        /**
         * Returns array of arrays for 'CHILD' type;
         * I.e. for 2 different children when each one has 2 declarations it returns: {
         *     user: [...],
         *     partner: [...],
         *     child: [
         *         [child_one_first_declaration, child_one_second_declaration],
         *         [child_two_first_declaration, child_two_second_declaration]
         *     ],
         *     other: []
         * }
         *
         * @param grouped
         * @param value
         */
        function handleChild(grouped, value) {
            var pushed = false;
            for(var i in grouped.child) {
                if (grouped.child[i][0].person.firstName === value.person.firstName
                    && grouped.child[i][0].person.lastName === value.person.lastName) {
                    grouped.child[i].push(value);
                    pushed = true;
                    break;
                }
            }
            if (!pushed) grouped.child.push([value]);
        }
    }
})();
